<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Unplanned Driver Activity Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this report shows driver driver HOS activity that does not overlap with scheduled bookings in CM</span>
    </div>

    <div style="position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>
    <br/>
    <div v-if="items && items.length > 0">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="log_link" slot-scope="row">
          <a :href="row.item.log_link">view log</a>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else style="font-size: 20px; font-weight: bold">
      <br/>
      no results found, click <b-button size="sm" @click="queue_request">Run Report</b-button> and check back in ~10 minutes
    </div>
  </div>
</template>
<script>
import {api_url, get_report_history, request_report} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'report_unplanned_hos',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),

      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields: [
        { key: 'driver_name', sortable: true},
        { key: 'vehicle_name', sortable: true},
        { key: 'hos_event_type', sortable: true },
        { key: 'log_start_time', sortable: true},
        { key: 'log_end_time', sortable: true},
        { key: 'log_link', label:'HOS Log', sortable: true}
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().subtract(1, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_report_history(this.user.tenant, 'UnplannedHOSActivity', moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async queue_request(){
      const {value: {data = []}} = await request_report(this.user.tenant, 'UnplannedHOSActivity', moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.$emit('showAlert', 'the report should be ready in ~10m', 'success', 5000)
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    details_fromDate(val) {
      this.load_data()
    }
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
